import parse from 'html-react-parser';

import {
    IframeCardMedia,
    IframeWrapper
} from '../Resources/IframeCard';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function TwoColumnVideo({ blockInfo }) {
    const mobile = useMediaQuery(theme => theme.breakpoints.down('lg'));

    return (
        <div className="overflow-hidden" style={{ backgroundColor: blockInfo.backgroundColor }}>
            <div className="relative mx-auto max-w-7xl py-16 px-6 lg:px-8">
                <div className={`mt-8 lg:grid ${blockInfo.orientation === "portrait" ? "lg:grid-cols-3" : "lg:grid-cols-2"} lg:gap-8`}>
                    <div 
                
                    className={`relative lg:row-start-1 ${blockInfo?.videoColumnPosition === 'left' ? 'lg:col-start-1' : 'lg:col-start-3'} w-full h-full `}>
                            <IframeCardMedia
       
                                        height="auto"
                     
                                        src={`https://player.vimeo.com/video/${blockInfo?.vimeoEmbedId}`}
                                        alt="Resource"
                                        className='border-0'
                                        webkitallowfullscreen="true"
                                        mozallowfullscreen="true"
                                    />
                   
                        
                    </div>
                    <div className={`mt-8 lg:mt-0 ${blockInfo.orientation === "portrait" ? "col-span-2" : ""}`}>
                        <div className='mx-auto max-w-prose' style={{ color: blockInfo?.textColor }}>
                            {parse(blockInfo?.columnText ?? '')}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
